module.exports = __webpack_public_path__ + "static/media/logoBanner.svg";